import React from "react";

export default function EmptyBlock({ text }) {
  return (
    <div>
      <p className="text-center font-22">{text}</p>
    </div>
  );
}
